import type { Profile } from 'next-auth';

export type ColorScheme = 'light' | 'dark';

export const DARK_MODE_CLASS = 'dark';

export const DARK_MODE_API_PATH = '/api/asv2/account/dark-mode';

/** Genesis user extended property shared with asv2 (`"true"` / `"false"`). */
export const GENESIS_DARK_MODE_PROPERTY = 'DARK_MODE';

export const parseDarkMode = (value?: string | null): boolean | undefined => {
  if (value === 'true') return true;
  if (value === 'false') return false;
  return undefined;
};

export const getGenesisDarkMode = (profile?: Profile): boolean | undefined => {
  const value = profile?.extendedProperties?.[GENESIS_DARK_MODE_PROPERTY];
  return typeof value === 'string' ? parseDarkMode(value) : undefined;
};

export const toColorScheme = (isDarkMode: boolean): ColorScheme =>
  isDarkMode ? 'dark' : 'light';

export const applyDarkModeClass = (root: Element, isDarkMode: boolean) => {
  root.classList.toggle(DARK_MODE_CLASS, isDarkMode);
};
